import instanceAPI from 'services/apis/axiosconfig';

export const getCarouselItems = () => {
  const request = instanceAPI.get('/public/get-carousel');
  return request.then((res) => ({
    ...res,
    data: {
      results: res.data.elements,
    },
  }));
};
